import script from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__